import { createReducer, on } from '@ngrx/store';
import * as AccountActions from './account.actions';
import { User } from '../../core/models/user.model';

export const accountFeatureKey = 'account';

export interface AccountState {
  user: User | null;
  loading: boolean;
  error?: any;
}

export const initialState: AccountState = {
  user: null,
  loading: false
};


export const reducer = createReducer(
  initialState,

  on(AccountActions.login, state => ({ ...state, loading: true })),
  on(AccountActions.loginSuccess, state => ({ ...state, loading: false })),
  on(AccountActions.loginFailure, (state, action) => ({ ...state, error: action.error, loading: false })),
  on(AccountActions.signUp, state => ({ ...state, loading: true })),
  on(AccountActions.signUpSuccess, state => ({ ...state, loading: false })),
  on(AccountActions.signUpFailure, (state, action) => ({ ...state, error: action.error, loading: false })),
  on(AccountActions.authenticated, (state, action) => ({ ...state, user: action.user, loading: false })),
  on(AccountActions.notAuthenticated, state => ({ ...state, ...initialState })),
  on(AccountActions.logout, state => ({ ...state, loading: true })),

);

